const mytripsCatalog = new Set();

// Error management
mytripsCatalog
    .add('loadingMyTripsDialog')
    .add('loadingMyTripsErrorDialog')
    .add('page-load-trip-details-flights')
    .add('page-load-trip-details-dp')
    .add('mytrips-mmb-btn')
    .add('trip-details-mmb-btn');

export default mytripsCatalog;
